import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import AppShell from "../../components/AppShell";
import api from "../../lib/api";
import { LumiMascot } from "../../components/Brand";
import { Award, Star, Flame, Camera, Sparkles } from "lucide-react";

const ICONS = { camera: Camera, sparkles: Sparkles, flame: Flame };

export default function Rewards() {
  const { t } = useTranslation();
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/student/dashboard").then((r) => setData(r.data)); }, []);

  const badges = data?.badges || [];
  const stars = data?.stats?.stars || 0;
  const streak = data?.stats?.streak_days || 0;

  const themes = [
    { key: "space",   name: "Space Explorer",   unlockedAt: 100 },
    { key: "ocean",   name: "Deep Ocean",       unlockedAt: 250 },
    { key: "jungle",  name: "Jungle Adventure", unlockedAt: 400 },
    { key: "cosmos",  name: "Cosmic Master",    unlockedAt: 600 },
  ];

  return (
    <AppShell isStudent>
      <h1 className="font-student font-bold text-3xl text-slate-900">{t("rewards.title")}</h1>
      <p className="text-slate-600">{t("rewards.subtitle")}</p>

      <div className="grid md:grid-cols-3 gap-4 mt-6">
        <div className="hb-card p-6 flex items-center gap-3">
          <div className="w-12 h-12 rounded-lg bg-yellow-500 text-white flex items-center justify-center"><Star className="w-6 h-6"/></div>
          <div><div className="font-student font-bold text-3xl">{stars}</div><div className="text-xs uppercase text-slate-500">{t("student.stars")}</div></div>
        </div>
        <div className="hb-card p-6 flex items-center gap-3">
          <div className="w-12 h-12 rounded-lg bg-orange-500 text-white flex items-center justify-center"><Flame className="w-6 h-6"/></div>
          <div><div className="font-student font-bold text-3xl">{streak}</div><div className="text-xs uppercase text-slate-500">{t("rewards.dayStreak")}</div></div>
        </div>
        <div className="hb-card p-6 flex items-center gap-3">
          <div className="w-12 h-12 rounded-lg bg-green-600 text-white flex items-center justify-center"><Award className="w-6 h-6"/></div>
          <div><div className="font-student font-bold text-3xl">{badges.length}</div><div className="text-xs uppercase text-slate-500">{t("rewards.badgesLabel")}</div></div>
        </div>
      </div>

      <h2 className="font-adult font-bold text-2xl text-slate-900 mt-8">{t("rewards.badgesLabel")}</h2>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 mt-3">
        {badges.length === 0 && (
          <div className="col-span-full hb-card p-6 flex items-center gap-3">
            <LumiMascot size={64} />
            <div className="text-slate-700 text-sm">{t("student.earnFirstBadge")}</div>
          </div>
        )}
        {badges.map((b) => {
          const Icon = ICONS[b.icon] || Award;
          return (
            <div key={b.key} className="hb-card p-4 text-center">
              <div className="w-12 h-12 mx-auto rounded-full bg-yellow-100 flex items-center justify-center"><Icon className="w-6 h-6 text-yellow-700"/></div>
              <div className="mt-2 font-semibold text-slate-900 text-sm">{b.name}</div>
            </div>
          );
        })}
      </div>

      <h2 className="font-adult font-bold text-2xl text-slate-900 mt-8">{t("rewards.themes")}</h2>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 mt-3">
        {themes.map((th) => {
          const unlocked = stars >= th.unlockedAt;
          return (
            <div key={th.key} className={`hb-card p-4 text-center ${unlocked ? "" : "opacity-60"}`}>
              <div className="text-4xl">{unlocked ? "★" : "☆"}</div>
              <div className="mt-1 font-semibold text-slate-900 text-sm">{th.name}</div>
              <div className="text-xs text-slate-500">{unlocked ? t("rewards.unlocked") : t("rewards.unlockAt", { n: th.unlockedAt })}</div>
            </div>
          );
        })}
      </div>
    </AppShell>
  );
}
